import {detectBreakpoint} from "@utilities/sal-breakpoint/sal-breakpoint";
import {animation, availableAnimations} from "@global/global-animation";
import {overlay} from "@utilities/sal-overlay/sal-overlay";

class Navigation {
    constructor() {
        this.CONSTANTS = {
            ACTIVE_CLASS: 'js-active',
            PARENT_ACTIVE_CLASS: 'js-has-active-child',
            PANE_HIDING_CLASS: 'navlink__pane',
            BACKGROUND_CLASS: 'overlay',
            BACKGROUND_CLASS_ACTIVE: 'show',
            SLIDEOUT_CLASS: 'main-navigation__slideout',
            NAVIGATION_BACK_CLASS: 'navigation--back',
            QUICKLINKS_CLASS: 'global-header__quicklinks'
        };

        this.state = {
            activeLinkId: null,
            activeElementReference: null,
            overlay: false,
            namespace: null,
            parent: null,
            breakpoint: null,
            reset: (stateObject) => {
                stateObject.activeElementReference = null;
                stateObject.activeLinkId = null;
                stateObject.parent = null;
            },
            restoreParent: (stateObject) => {
                stateObject.activeElementReference = stateObject.parent.activeElementReference;
                stateObject.activeLinkId = stateObject.parent.activeLinkId;
                stateObject.parent = null;
                stateObject.activeElementReference.classList.add(this.CONSTANTS.ACTIVE_CLASS);
            },
            setNamespace: (stateObject, namespace) => {
                stateObject.namespace = namespace;
            },
            setBreakpoint: (stateObject, breakpoint) => {
                stateObject.breakpoint = breakpoint;
            },
            setParent: (stateObject, parentId) => {
                stateObject.parent = {
                    activeElementReference: document.querySelector(`${stateObject.namespace}#${parentId}`),
                    activeLinkId: parentId
                };
            },
            hasParent: (stateObject) => {
                if (stateObject.parent) {
                    return stateObject.parent.activeLinkId;
                }
            },
            showOverlay: (stateObject, visible = true) => {
                if (visible) {
                    stateObject.overlay = true;
                    overlay.showOverlay(overlay.options.stacking.behindMenu,'globalnavigaion', true, false);
                } else {
                    stateObject.overlay = false;
                    overlay.hideOverlay('globalnavigaion');
                }
                return stateObject.overlay;
            }
        };

        this.actions = {
            measureNodeHeight: (node) => {
                let clone = node.cloneNode(true);
                clone.style.position = 'fixed';
                clone.style.right = '5000px';
                clone.style.display = 'block';

                document.body.append(clone);
                let cloneHeight = clone.scrollHeight;
                document.body.removeChild(clone);
                return cloneHeight;
            }
        };

        this.eventHandler = {
            menuOpenHandler: (e) => {
                e.preventDefault();
                const active = e.target.dataset.target;
                const activePane = document.querySelector(`${this.state.namespace}#${active}`);
                const activeLevel = parseInt(e.target.dataset.level);
                const navigationSlideout = document.querySelector(`${this.state.namespace}.${this.CONSTANTS.SLIDEOUT_CLASS}`);

                if (activeLevel === 3) {
                    const parentId = active.slice(0, active.lastIndexOf('-'));
                    const parentElementReference = document.querySelector(`${this.state.namespace}#${parentId}`);

                    // Toggle submenu point
                    if (this.state.breakpoint !== 'md' || this.state.breakpoint !== 'sm' || this.state.breakpoint !== 'xs') {
                        if (active === this.state.activeLinkId) {
                            e.currentTarget.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                            this.state.activeElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                            this.state.restoreParent(this.state, parent);
                            return;
                        }
                    }

                    this.state.activeElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);

                    if (this.state.hasParent(this.state)) {
                        this.state.parent.activeElementReference.classList.remove(this.CONSTANTS.PARENT_ACTIVE_CLASS);
                    } else {
                        parentElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    // save parent
                    this.state.setParent(this.state, parentId);

                    // Set new state
                    this.state.activeLinkId = active;
                    this.state.activeElementReference = activePane;
                    this.state.activeLevel = activeLevel;

                    // set active classes on parent and child
                    this.state.parent.activeElementReference.classList.add(this.CONSTANTS.PARENT_ACTIVE_CLASS);
                    this.state.activeElementReference.classList.add(this.CONSTANTS.ACTIVE_CLASS);

                    if (this.state.parent.activeElementReference.querySelector(`.${this.CONSTANTS.ACTIVE_CLASS}`)) {
                        this.state.parent.activeElementReference.querySelector(`.${this.CONSTANTS.ACTIVE_CLASS}`).classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    e.currentTarget.classList.add(this.CONSTANTS.ACTIVE_CLASS);

                    if (this.state.breakpoint === 'md' || this.state.breakpoint === 'sm' || this.state.breakpoint === 'xs') {
                        activePane.parentElement.style.display = 'block';
                        activePane.parentElement.style.minWidth = '100%';
                        parentElementReference.parentElement.style.minWidth = '100%';

                        const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                        mainNavigation.style.height = `${mainNavigation.scrollHeight}px`;

                        const level2 = parentElementReference.parentElement;
                        const level3 = activePane.parentElement;

                        const level2Height = this.actions.measureNodeHeight(level2);
                        const level3Height = this.actions.measureNodeHeight(level3);
                        if (level2Height > level3Height) {
                            animation.addAnimation(level2, availableAnimations.slides.slideOutLeft, null, [
                                {
                                    eventType: 'animationstart',
                                    eventCallback: e => {
                                        e.target.style.display = 'block';
                                    }
                                },
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        e.target.style.display = 'none';
                                        e.target.style.minWidth = '';
                                        mainNavigation.style.height = `${level3Height}px`;
                                    }
                                }
                            ]);

                            animation.addAnimation(level3, availableAnimations.slides.slideInRight, null, [
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        e.target.style.minWidth = '';
                                    }
                                }
                            ]);
                        } else {
                            animation.addAnimation(level2, availableAnimations.slides.slideOutLeft, null, [
                                {
                                    eventType: 'animationstart',
                                    eventCallback: e => {
                                        e.target.style.display = 'block';
                                        mainNavigation.style.height = `${level3Height}px`;
                                    }
                                },
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        e.target.style.display = 'none';
                                        e.target.style.minWidth = '';
                                    }
                                }
                            ]);

                            animation.addAnimation(level3, availableAnimations.slides.slideInRight, null, [
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        e.target.style.minWidth = '';
                                    }
                                }
                            ]);
                        }
                    }
                }
                // Target is a level 2 menu item
                if (activeLevel === 2) {
                    const activePaneTeaser = document.querySelector(`${this.state.namespace}#${active}-teaser`);
                    const slideoutReference = document.querySelector(`${this.state.namespace}.${this.CONSTANTS.SLIDEOUT_CLASS}`);
                    // Toggle menu point
                    if (this.state.breakpoint !== 'md' || this.state.breakpoint !== 'sm' || this.state.breakpoint !== 'xs') {
                        if (active === this.state.activeLinkId) {
                            slideoutReference.style.maxHeight = ``;
                            this.state.activeElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                            this.state.activePaneTeaserReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                            document.querySelector(`${this.state.namespace}.decoration--vertical`).classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                            this.state.reset(this.state);
                            this.state.showOverlay(this.state, false);
                            return;
                        }
                    }

                    // Menu is open but new menu item selected
                    if (this.state.activeElementReference) {
                        this.state.activeElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                        this.state.activePaneTeaserReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    if (this.state.parent) {
                        this.state.parent.activeElementReference.classList.remove(this.CONSTANTS.PARENT_ACTIVE_CLASS);
                    }

                    // Set new state
                    this.state.activeLinkId = active;
                    this.state.activeElementReference = activePane;
                    this.state.activePaneTeaserReference = activePaneTeaser;
                    this.state.activeLevel = activeLevel;

                    if (this.state.breakpoint !== 'md' || this.state.breakpoint !== 'sm' || this.state.breakpoint !== 'xs') {
                        this.state.showOverlay(this.state, true);
                    }

                    activePane.classList.add(this.CONSTANTS.ACTIVE_CLASS);

                    document.querySelector(`${this.state.namespace}.${this.CONSTANTS.SLIDEOUT_CLASS}`).style.display = 'flex';
                    slideoutReference.style.maxHeight = `1000px`;
                    this.state.activePaneTeaserReference.classList.add(this.CONSTANTS.ACTIVE_CLASS);

                    if (this.state.breakpoint === 'md' || this.state.breakpoint === 'sm' || this.state.breakpoint === 'xs') {

                        const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                        mainNavigation.style.height = `${mainNavigation.scrollHeight}px`;

                        const quicklink = document.querySelector(`${this.state.namespace}.${this.CONSTANTS.QUICKLINKS_CLASS}`);
                        quicklink.style.display = 'none';

                        let copy = navigationSlideout.cloneNode(true);
                        copy.querySelector(`.slideout__level${activeLevel}`).style.display = 'block';
                        const elementToShowHeight = this.actions.measureNodeHeight(copy);

                        if (elementToShowHeight <= mainNavigation.clientHeight) {
                            animation.addAnimation(document.querySelector(`${this.state.namespace}.list-level-1`), availableAnimations.slides.slideOutLeft, null, [
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        document.querySelector(`${this.state.namespace}.main-navigation`).style.height = `${navigationSlideout.clientHeight}px`;
                                        e.target.style.display = 'none';
                                    }
                                },
                                {
                                    eventType: 'animationstart',
                                    eventCallback: e => {
                                        e.target.style.display = 'block';
                                        document.querySelector(`${this.state.namespace}.main-navigation`).style.height = `${e.target.clientHeight}px`;
                                    }
                                }
                            ]);
                        } else {
                            animation.addAnimation(document.querySelector(`${this.state.namespace}.list-level-1`), availableAnimations.slides.slideOutLeft, null, [
                                {
                                    eventType: 'animationend',
                                    eventCallback: e => {
                                        document.querySelector(`${this.state.namespace}.main-navigation`).style.height = `${navigationSlideout.clientHeight}px`;
                                        e.target.style.display = 'none';
                                    }
                                },
                                {
                                    eventType: 'animationstart',
                                    eventCallback: e => {
                                        e.target.style.display = 'block';
                                        document.querySelector(`${this.state.namespace}.main-navigation`).style.height = `${elementToShowHeight}px`;
                                    }
                                }
                            ]);
                        }

                        activePane.parentNode.style.display = 'block';
                        animation.addAnimation(activePane.parentNode, availableAnimations.slides.slideInRight);
                    }
                }
            },
            leaveMenu: (e) => {
                e.stopPropagation();
                const eventTrigger = e.target.closest(`.${this.CONSTANTS.BACKGROUND_CLASS}`);

                if (eventTrigger.classList.contains(this.CONSTANTS.BACKGROUND_CLASS)) {

                    if (eventTrigger.dataset.dismissable === "true") {
                        this.state.showOverlay(this.state, false);
                    }


                    if (this.state.parent) {
                        this.state.parent.activeElementReference.classList.remove(this.CONSTANTS.PARENT_ACTIVE_CLASS);
                        this.state.parent.activeElementReference.querySelector(`.${this.CONSTANTS.ACTIVE_CLASS}`).classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    document.querySelector(`${this.state.namespace}.${this.CONSTANTS.SLIDEOUT_CLASS}`).style.display = 'none';
                    document.querySelector(`${this.state.namespace}.decoration--vertical`).classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    if (this.state.activePaneTeaserReference) {
                        this.state.activePaneTeaserReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    if (this.state.activeElementReference) {
                        this.state.activeElementReference.classList.remove(this.CONSTANTS.ACTIVE_CLASS);
                    }

                    this.state.reset(this.state);
                }
            },
            navigationBack: e => {
                const navigationBackReference = e.target;
                const slideout = navigationBackReference.closest(`.slideout`);
                const level1 = document.querySelector(`${this.state.namespace}.list-level-1`);
                const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                const elementToShowHeight = this.actions.measureNodeHeight(level1);

                if (slideout.classList.contains(`slideout__level2`)) {
                    const quicklink = document.querySelector(`${this.state.namespace}.${this.CONSTANTS.QUICKLINKS_CLASS}`);
                    quicklink.style.display = '';

                    if (elementToShowHeight <= mainNavigation.clientHeight) {
                        animation.addAnimation(slideout, availableAnimations.slides.slideOutRight, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: e => {
                                    e.target.style.display = 'none'
                                }
                            }
                        ]);

                        level1.style.height = undefined;
                        level1.style.display = '';
                        animation.addAnimation(level1, availableAnimations.slides.slideInLeft, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: () => {
                                    const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                                    mainNavigation.style.height = `${this.actions.measureNodeHeight(level1)}px`;
                                    mainNavigation.style.display = '';
                                }
                            }
                        ]);
                    } else {
                        animation.addAnimation(slideout, availableAnimations.slides.slideOutRight, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: e => {
                                    e.target.style.display = 'none'
                                }
                            }
                        ]);

                        level1.style.height = undefined;
                        level1.style.display = '';
                        animation.addAnimation(level1, availableAnimations.slides.slideInLeft, null, [
                            {
                                eventType: 'animationstart',
                                eventCallback: () => {
                                    const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                                    mainNavigation.style.height = `${this.actions.measureNodeHeight(level1)}px`;
                                }
                            }
                        ]);
                    }
                }

                if (slideout.classList.contains(`slideout__level3`)) {
                    const level2 =  slideout.parentElement.querySelector(`.slideout__level2`);
                    const level2Height = this.actions.measureNodeHeight(level2);
                    const level3Height = this.actions.measureNodeHeight(slideout);
                    if (level2Height <= level3Height) {
                        animation.addAnimation(slideout, availableAnimations.slides.slideOutRight, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: e => {
                                    e.target.style.display = 'none'
                                }
                            }
                        ]);

                        level2.style.height = undefined;
                        level2.style.display = '';
                        animation.addAnimation(level2, availableAnimations.slides.slideInLeft, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: () => {
                                    const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                                    mainNavigation.style.height = `${this.actions.measureNodeHeight(level2)}px`;
                                }
                            }
                        ]);
                    } else {
                        animation.addAnimation(slideout, availableAnimations.slides.slideOutRight, null, [
                            {
                                eventType: 'animationend',
                                eventCallback: e => {
                                    e.target.style.display = 'none'
                                }
                            }
                        ]);

                        level2.style.height = undefined;
                        level2.style.display = '';
                        animation.addAnimation(level2, availableAnimations.slides.slideInLeft, null, [
                            {
                                eventType: 'animationstart',
                                eventCallback: () => {
                                    const mainNavigation = document.querySelector(`${this.state.namespace}.main-navigation`);
                                    mainNavigation.style.height = `${this.actions.measureNodeHeight(level2)}px`;
                                }
                            }
                        ]);
                    }
                }
            }
        };
    }

    init(namespace) {
        if (namespace) {
            this.state.setNamespace(this.state, `.${namespace} `);
        } else {
            this.state.setNamespace(this.state, ``);
        }

        const navigationBack = document.querySelectorAll(`${this.state.namespace}.${this.CONSTANTS.NAVIGATION_BACK_CLASS}`);
        if (navigationBack !== null) {
            navigationBack.forEach(navigationBackReference => {
                navigationBackReference.addEventListener('click', this.eventHandler.navigationBack);
            });
        }

        this.state.setBreakpoint(this.state, detectBreakpoint());
        window.addEventListener('resize', () => {
            this.state.setBreakpoint(this.state, detectBreakpoint());
        });

        try {
            document.querySelector(`${this.state.namespace}.${this.CONSTANTS.SLIDEOUT_CLASS}`).style.display = 'none';
            const navigationItems = document.querySelectorAll(`${this.state.namespace}.main-navigation__link[data-target]`);

            navigationItems.forEach((element) => {
                element.addEventListener('click', this.eventHandler.menuOpenHandler, false)
            });

            const overlayPane = document.querySelector(`.${this.CONSTANTS.BACKGROUND_CLASS}`);
            overlayPane.addEventListener('click', this.eventHandler.leaveMenu, false);

        } catch (error) {
            document.querySelectorAll(`${this.state.namespace}.${this.CONSTANTS.PANE_HIDING_CLASS}`).forEach((element) => {
                element.classList.remove(this.CONSTANTS.PANE_HIDING_CLASS);
            });
            new Error(`Menu could not be initialized ${error}`);
        }
    }
}

export {Navigation};
